import React, { createContext, useContext, useState, useMemo} from "react";


const LoadingContext = createContext({
    isLoading: false,
    startLoading: () => {},
    stopLoading: () => {},
});

export const LoadingProvider = ({ children}) => {
    const [pendingCalls, setPendingCalls] = useState(0);

    const startLoading = () => {
        setPendingCalls((prev) => prev + 1);
    };

    const stopLoading = () => {
        setPendingCalls((prev) => Math.max(prev - 1, 0));
    };

    const value = useMemo(
        () => ({
            isLoading: pendingCalls > 0,
            startLoading,
            stopLoading,
        }),
        [pendingCalls]
    );

    return (
        <LoadingContext.Provider value={value}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);